// extracted by mini-css-extract-plugin
module.exports = {"page":"XO9_AuSi6o94W23PcFqfb"};